const checkIfBrokerDisbaled = (val = '', options = []) => {
  const { brokerDisabled = false } =
    options.find((op) => op && op.value && op.value === val) || {};

  return brokerDisabled;
};

export function viewAlerts(data, alerts, brokersDataAll = []) {
  let newData = [];

  for (let index = 0; index < data.length; index++) {
    const element = data[index];
    const broker = element.broker;
    const isBrokerDisabled = checkIfBrokerDisbaled(broker, brokersDataAll);
    const isStoplossTrailing = element.stoplossTrailing || false;
    const hasError = element.hasError || false;
    const hasWaitingWT = element.hasWaitingWT || false;
    const noErrors =
      !isBrokerDisabled && !isStoplossTrailing && !hasError && !hasWaitingWT;

    if (alerts.includes(null) && noErrors) {
      newData.push(element);
      continue;
    }

    if (alerts.includes('disabledBroker') && isBrokerDisabled) {
      newData.push(element);
      continue;
    }

    if (alerts.includes('hasError') && hasError) {
      newData.push(element);
      continue;
    }

    if (alerts.includes('hasWaitingWT') && hasWaitingWT) {
      newData.push(element);
      continue;
    }

    if (alerts.includes('stoplossTrailing') && isStoplossTrailing) {
      newData.push(element);
      continue;
    }
  }

  return [...newData];
}
